


























import settings from '@/settings'
import n from '@/utils/notifications'

export default {
    name: 'lost_password_part'

    props:
        send_email:
            type: String
        unusable:
            type:
                Boolean

    data: ()->
        email: @send_email

    methods:
        new_password: ()->
            self = @
            @$http.post(settings.lost_password_url, {"email":@email})
            .then (resp)->
                if resp.body.status == "Failed"
                    n.error("Email : ", resp.body.message)
                else
                    n.success_message(resp.body.message)
            return

        cancel: ()->
            @$emit('cancel')
            return
}
